<template>
    <kt-row>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="mobile">
                    {{ $t('label.phone') }}
                </kt-form-label>
                <kt-form-control
                        id="mobile"
                        name="mobile"
                        style="direction: ltr"
                        v-model="form_data.mobile"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="account_number">
                    {{ $t('label.account_number') }}
                </kt-form-label>
                <kt-form-control
                        id="account_number"
                        name="account_number"
                        v-model="form_data.account_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="national_code">
                    {{ $t('label.national_code') }}
                </kt-form-label>
                <kt-form-control
                        id="national_code"
                        name="national_code"
                        style="direction: ltr"
                        v-model="form_data.national_code"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="sheba_number">
                    {{ $t('label.sheba_number') }}
                </kt-form-label>
                <kt-form-control
                        id="sheba_number"
                        name="sheba_number"
                        style="direction: ltr"
                        v-model="form_data.sheba_number"
                        class="form-control transfers_destination_number"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="username">
                    {{ $t('label.username') }}
                </kt-form-label>
                <kt-form-control
                        id="username"
                        name="username"
                        style="direction: ltr"
                        v-model="form_data.username"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="password">
                    {{ $t('label.password') }}
                </kt-form-label>
                <kt-form-control
                        id="password"
                        name="password"
                        type="password"
                        style="direction: ltr"
                        v-model="form_data.password"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="guild_id">
                    {{ $t('label.subcategory_code') }}
                </kt-form-label>
                <select size="4"
                                id="guild_id"
                                name="guild_id"
                                v-model="form_data.guild_id"
                                class="form-control kt-selectpicker-live"
                >
                    <option
                            v-bind:key="category.key"
                            v-for="category in subcategories"
                            v-bind:value="category.key"
                            :selected="category.key == form_data.guild_id"
                    >
                        {{ category.value }}
                    </option>
                </select>
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
import $ from "jquery";
import Inputmask from "inputmask";
import {i18n} from '@/plugins/i18n'
import {subcategories} from '@/constants/subcategories'

export default {
    data(){
      return {
          subcategories
      }
    },
    props: {
        form_data: {
            required: true
        },
    },
    methods: {

        initShebaMask() {
            Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.transfers_destination_number'));
        },
        afterDispatch() {
            $('.kt-selectpicker-live').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_chose')
            });
        },
    },
    mounted() {
        this.afterDispatch();
        this.initShebaMask()
    }
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>